import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import Tabs, { Tab } from "material-ui/Tabs";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "row"
  },
  tabs: {
    flex: "1 1 auto"
  },
  tabsRoot: {
    minHeight: 36
  },
  tabRoot: {
    height: 36
  }
});

const OvSubbar = props => {
  const {
    classes,
    tabIndex,
    secondaryControl,
    history,
    labels,
    persistTab
  } = props;

  const tabs = labels.map((label, i) => (
    <Tab key={i} label={label} classes={{ root: classes.tabRoot }} />
  ));

  const onChangeTab = (event, tabIndex) => {
    persistTab(tabIndex);
    history.push(`/overview/${labels[tabIndex]}${history.location.search}`);
  };

  return (
    <div className={classes.root}>
      <Tabs
        classes={{
          root: classes.tabsRoot
        }}
        className={classes.tabs}
        value={tabIndex}
        onChange={onChangeTab}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </Tabs>

      {secondaryControl}
    </div>
  );
};

OvSubbar.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  labels: PropTypes.array.isRequired,
  secondaryControl: PropTypes.element,
  persistTab: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export { OvSubbar };

export default withStyles(styles, { name: "OvSubbar" })(withRouter(OvSubbar));



// WEBPACK FOOTER //
// ./src/OvSubbar.js